module.exports = __webpack_public_path__ + "static/media/usuario-background.066fbefd.jpg";